<div class="form-list">
  <div class="form-list">
    <mat-form-field class="zone-list">
      <mat-chip-listbox #chipList>
        @for (item of selectedZones; track item) {
          <mat-chip-row (removed)="remove(item)">
            {{ item.properties.nom }}
            <mat-icon matChipRemove>close</mat-icon>
          </mat-chip-row>
        }
      </mat-chip-listbox>
      <input
        #input="matAutocompleteTrigger"
        type="text"
        placeholder="{{ 'igo.geo.spatialFilter.listLabel' | translate }}"
        matInput
        [formControl]="formControl"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="select($event)"
      >
        @for (entity of filteredEntities$ | async; track entity) {
          <mat-option
            [value]="entity"
            [disabled]="isSelected(entity) || inFlightIds.has(entity.meta.id)"
          >
            {{ entity.properties.nom }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <div>
      <div class="buffer-div">
        <mat-form-field class="buffer">
          <mat-label>{{
            'igo.geo.spatialFilter.buffer' | translate
          }}</mat-label>
          <input
            type="number"
            matInput
            placeholder="{{ 'igo.geo.spatialFilter.buffer' | translate }}"
            [formControl]="bufferFormControl"
            [value]="0"
            [readonly]="selectedZones.length === 0"
          />
        </mat-form-field>

        <mat-form-field class="unit-field">
          <mat-select
            [value]="measureUnit"
            (selectionChange)="onMeasureUnitChange($event.value)"
          >
            @for (measureUnit of measureUnits; track measureUnit) {
              <mat-option [value]="measureUnit">
                {{ 'igo.geo.measure.' + measureUnit | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
